<template>
  <v-card outlined class="pa-4">
    <p class="text-h2 font-weight-bold primary--text ma-0">{{ quantity }}</p>
    <p class="text-uppercase grey--text text--darken-2">Total</p>
    <p>{{ title }}</p>
  </v-card>
</template>

<script>
export default {
  props: {
    quantity: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    }
  },
}
</script>
